import React from 'react';
import { Button } from '../buttons/Button';

/**
 * Simple Yes or No confirmation modal
 * 
 * @param {Boolean} showModal
 * @param {string} message
 * @param {Function} handleConfirm
 * @param {Function} handleCancel
 * @param {string} confirmButtonText
 * @param {string} cancelButtonText
 * @param {string} buttonVariant
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - UI
 */
export const ConfirmModal = ({
    showModal, 
    message, 
    handleConfirm, 
    handleCancel,
    confirmButtonText,
    cancelButtonText,
    buttonVariant = 'danger'
}) => {
    if(!showModal) return null

    return (
        <>

            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white p-8 rounded-lg max-w-md mx-4 flex flex-col items-center">
                    <p className="text-md text-center">{message}</p>
                    <div className="mt-6 flex max-[330px]:flex-col flex-row items-center justify-center">
                        <Button variant={buttonVariant} onClick={handleConfirm} className='m-2'>{confirmButtonText || "Yes"}</Button>
                        <Button variant="cancel" onClick={handleCancel} className='m-2'>{cancelButtonText || "No"}</Button>
                    </div>
                </div>
            </div>

        </>
    )    
}

